export default "__VITE_ASSET__AYr4MBaD__"